import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MapWithSidebarModule } from '@ui/shared/feature-map';
import { AsyncPipe } from '@angular/common';
import { BaseAppComponent } from '@ui/shared/feature-config';
import type { SportMapItem } from './definitions/sport-map-item';
import { SportMapItemPopupContentComponent } from './components/sport-map-item-popup-content/sport-map-item-popup-content.component';
import { SportMapItemDetailsComponent } from './components/sport-map-item-details/sport-map-item-details.component';
import { FilterMapperComponent } from '@ui/shared/ui-filter';

@Component({
    selector: 'ui-sport-map-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        AsyncPipe,
        MapWithSidebarModule,
        SportMapItemDetailsComponent,
        FilterMapperComponent,
    ],
})
export class AppComponent extends BaseAppComponent<SportMapItem> {
    constructor() {
        super(SportMapItemPopupContentComponent);
    }
}
